import { RotateCcw } from 'lucide-react';
import { DEFAULT_FILTERS } from '../utils/resultFilters';

export default function ResultsFilters({ type, filters, onChange, results, onReset }) {
  const airlines = type === 'flights'
    ? [...new Set(results.map((r) => r.airlineCode || r.airline).filter(Boolean))]
    : [];
  const companies = type === 'cars'
    ? [...new Set(results.map((r) => r.company).filter(Boolean))]
    : [];

  const set = (key, value) => onChange({ ...filters, [key]: value });

  const toggleAirline = (code) => {
    const next = filters.airlines.includes(code)
      ? filters.airlines.filter((a) => a !== code)
      : [...filters.airlines, code];
    set('airlines', next);
  };

  return (
    <div className="filters-panel">
      <label>
        Sort by
        <select value={filters.sort} onChange={(e) => set('sort', e.target.value)}>
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
          {type === 'flights' && (
            <>
              <option value="duration-asc">Duration: Shortest</option>
              <option value="duration-desc">Duration: Longest</option>
              <option value="depart-asc">Departure: Earliest</option>
            </>
          )}
          {type === 'hotels' && (
            <>
              <option value="rating-desc">Rating: Highest</option>
              <option value="stars-desc">Stars: Highest</option>
            </>
          )}
        </select>
      </label>

      <label>
        Min price: ${filters.minPrice}
        <input
          type="range"
          min={0}
          max={filters.maxPrice}
          step={25}
          value={filters.minPrice}
          onChange={(e) => set('minPrice', Number(e.target.value))}
        />
      </label>

      <label>
        Max price: ${filters.maxPrice}
        <input
          type="range"
          min={50}
          max={10000}
          step={50}
          value={filters.maxPrice}
          onChange={(e) => set('maxPrice', Number(e.target.value))}
        />
      </label>

      {type === 'flights' && (
        <>
          <label>
            Stops
            <select value={filters.stops} onChange={(e) => set('stops', e.target.value)}>
              <option value="any">Any</option>
              <option value="nonstop">Nonstop only</option>
              <option value="1">1 stop</option>
              <option value="2plus">2+ stops</option>
            </select>
          </label>
          <label>
            Cabin class
            <select value={filters.cabin} onChange={(e) => set('cabin', e.target.value)}>
              <option value="any">Any class</option>
              <option value="economy">Economy</option>
              <option value="premium_economy">Premium Economy</option>
              <option value="business">Business</option>
              <option value="first">First</option>
            </select>
          </label>
          {airlines.length > 0 && (
            <fieldset className="filter-checkboxes">
              <legend>Airlines</legend>
              {airlines.map((code) => (
                <label key={code} className="checkbox-row">
                  <input
                    type="checkbox"
                    checked={filters.airlines.includes(code)}
                    onChange={() => toggleAirline(code)}
                  />
                  {code}
                </label>
              ))}
            </fieldset>
          )}
        </>
      )}

      {type === 'hotels' && (
        <>
          <label>
            Minimum stars
            <select value={filters.minStars} onChange={(e) => set('minStars', Number(e.target.value))}>
              <option value={0}>Any</option>
              <option value={3}>3+ stars</option>
              <option value={4}>4+ stars</option>
              <option value={5}>5 stars</option>
            </select>
          </label>
          <label>
            Minimum rating: {filters.minRating.toFixed(1)}
            <input
              type="range"
              min={0}
              max={5}
              step={0.5}
              value={filters.minRating}
              onChange={(e) => set('minRating', Number(e.target.value))}
            />
          </label>
        </>
      )}

      {type === 'cars' && (
        <>
          <label>
            Car type
            <select value={filters.carType} onChange={(e) => set('carType', e.target.value)}>
              <option value="any">Any</option>
              <option value="Economy">Economy</option>
              <option value="Compact">Compact</option>
              <option value="SUV">SUV</option>
              <option value="Luxury">Luxury</option>
              <option value="Van">Van</option>
            </select>
          </label>
          <label>
            Rental company
            <select value={filters.company} onChange={(e) => set('company', e.target.value)}>
              <option value="any">Any</option>
              {companies.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </label>
          <label>
            Transmission
            <select value={filters.transmission} onChange={(e) => set('transmission', e.target.value)}>
              <option value="any">Any</option>
              <option value="Automatic">Automatic</option>
              <option value="Manual">Manual</option>
            </select>
          </label>
        </>
      )}

      {(type === 'packages' || type === 'cruises') && (
        <>
          {type === 'cruises' && (
            <label>
              Cabin type
              <select value={filters.cabinType} onChange={(e) => set('cabinType', e.target.value)}>
                <option value="any">Any</option>
                <option value="Interior">Interior</option>
                <option value="Ocean View">Ocean View</option>
                <option value="Balcony">Balcony</option>
                <option value="Suite">Suite</option>
              </select>
            </label>
          )}
          <label>
            Min nights: {filters.minNights || 'Any'}
            <input
              type="range"
              min={0}
              max={14}
              step={1}
              value={filters.minNights}
              onChange={(e) => set('minNights', Number(e.target.value))}
            />
          </label>
        </>
      )}

      <button type="button" className="btn-filter-reset" onClick={() => onReset(DEFAULT_FILTERS)}>
        <RotateCcw size={16} /> Reset filters
      </button>
    </div>
  );
}
